import { Row } from '@opendoor/atoms/box';
import { Button } from '@opendoor/atoms/button';
import { Dialog } from '@opendoor/atoms/dialog';
import { Text } from '@opendoor/atoms/text';

const ExitOfferDialog = ({
  open,
  leaving,
  error,
  onStay,
  onLeave,
}: {
  open: boolean;
  leaving: boolean;
  error: string | null;
  onStay: () => void;
  onLeave: () => Promise<void>;
}) => {
  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) onStay();
  };

  return (
    <Dialog.Root role="dialog" open={open} onOpenChange={handleOpenChange}>
      <Dialog size="sm" className="p-6 sm:w-110 sm:rounded-3xl sm:p-8">
        <Dialog.Title className="pb-3 pr-10 text-subheader-sm sm:text-subheader-sm">
          Abandon offer
        </Dialog.Title>
        <Dialog.Description className="text-body-md text-od-content-secondary">
          Offer has not been submitted yet. Your progress will be lost.
        </Dialog.Description>
        {error ? (
          <Text role="alert" className="pt-3 text-body-sm text-od-content-error">
            {error}
          </Text>
        ) : null}
        <Row className="flex-wrap justify-end gap-2 pt-5">
          <Button
            type="button"
            variant="secondary"
            size="md"
            onClick={onStay}
            disabled={leaving}
            aria-label="Cancel"
            analyticsName="cosmos-make-offer-cancel-exit"
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            size="md"
            onClick={onLeave}
            disabled={leaving}
            loading={leaving}
            aria-label="Abandon offer"
            analyticsName="cosmos-make-offer-confirm-exit"
          >
            Abandon offer
          </Button>
        </Row>
      </Dialog>
    </Dialog.Root>
  );
};

export default ExitOfferDialog;
